// src/calls/media/webMedia.js
export const webMedia = {
    getUserMedia: (c) => navigator.mediaDevices.getUserMedia(c),
    RTCPeerConnection: window.RTCPeerConnection,
    RTCSessionDescription: window.RTCSessionDescription,
    RTCIceCandidate: window.RTCIceCandidate,
    MediaStream: window.MediaStream
};
